import React, { useState, useEffect } from 'react';
import { analyticsAPI } from '../services/api';

const Analytics = () => {
  const [meetingsData, setMeetingsData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchMeetingsNeedingGoals();
  }, [selectedDate]);

  const fetchMeetingsNeedingGoals = async () => {
    setLoading(true);
    try {
      const response = await analyticsAPI.getMeetingsNeedingGoals(selectedDate);
      setMeetingsData(response.data);
    } catch (error) {
      console.error('Error fetching analytics:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Analytics</h1>

      {/* Date Selector */}
      <div className="bg-white rounded-lg shadow p-6 mb-8">
        <div className="max-w-md">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Meeting Month
          </label>
          <input
            type="month"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>

      {/* Meetings Needing Goals */}
      <div className="bg-white rounded-lg shadow">
        <div className="px-6 py-4 border-b border-gray-200">
          <h2 className="text-xl font-semibold">
            Groups Needing Goals for {selectedDate}
          </h2>
        </div>

        {loading ? (
          <div className="flex justify-center items-center h-32">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
        ) : meetingsData ? (
          <div className="p-6">
            {meetingsData.groups && meetingsData.groups.length > 0 ? (
              <div className="space-y-6">
                <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-6">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div className="ml-3">
                      <h3 className="text-sm font-medium text-red-800">
                        Action Required
                      </h3>
                      <div className="mt-2 text-sm text-red-700">
                        <p>{meetingsData.groups.length} group(s) have members without goals set for {selectedDate}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {meetingsData.groups.map(group => (
                  <div key={group.group_id} className="border border-gray-200 rounded-lg p-4">
                    <div className="flex justify-between items-start mb-3">
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900">{group.group_name}</h3>
                        <p className="text-sm text-gray-600">{group.schedule} at {group.time}</p>
                      </div>
                      <span className="bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded">
                        {group.members_without_goals.length} missing
                      </span>
                    </div>
                    
                    <div>
                      <h4 className="font-medium text-gray-700 mb-2">Members without goals:</h4>
                      <div className="flex flex-wrap gap-2">
                        {group.members_without_goals.map(member => (
                          <span key={member.member_id} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                            {member.member_name}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-8">
                <svg className="mx-auto h-12 w-12 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <h3 className="mt-2 text-sm font-medium text-gray-900">All caught up!</h3>
                <p className="mt-1 text-sm text-gray-500">
                  All members have goals set for {selectedDate}.
                </p>
              </div>
            )}
          </div>
        ) : (
          <div className="p-6 text-center text-gray-500">
            No data available
          </div>
        )}
      </div>
    </div>
  );
};

export default Analytics;